// test857
(857 && 0);
